"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("./tools_data/rag/component");
const component_2 = require("./tools_data/web-search/component");
const component_3 = require("./tools_data/product-card/component");
const component_4 = require("./tools_data/product-compare/component");
const component_5 = require("./tools_data/detect-contact-data/component");
const component_6 = require("./tools_data/detect-tasks/component");
const component_7 = require("./tools_data/offer-creator/component");
const component_8 = require("./tools_data/quick-offer/component");
const component_9 = require("./tools_data/send-contact-form/component");
const component_10 = require("./tools_data/convo-tags/component");
const component_11 = require("./tools_data/gallery-tags/component");
const component_12 = require("./tools_data/ask-for-voucher/component");
const component_13 = require("./tools_data/dynamic-listings/component");
const component_14 = require("./tools_data/product-api-search/component");
const component_15 = require("./tools_data/api-tool/component");
component_1.ToolsRagDataComponent;
component_2.RWSToolsWebSearchDataComponent;
component_3.RWSToolsProductCardDataComponent;
component_4.RWSToolsProductCompareDataComponent;
component_5.RWSToolsDetectContactDataComponent;
component_6.RWSToolsDetectTasksDataComponent;
component_7.RWSToolsOfferCreatorDataComponent;
component_8.RWSToolsQuickOfferDataComponent;
component_9.RWSToolsSendContactFormDataComponent;
component_10.RWSToolsConvoTagsDataComponent;
component_11.RWSToolsGalleryTagsDataComponent;
component_12.RWSToolsAskForVoucherDataComponent;
component_13.RWSToolsDynamicListingsDataComponent;
component_14.RWSToolsProductAPISearchDataComponent;
component_15.RWSToolsApiToolDataComponent;
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-container">
    <div class="tools-header">
        <h2 class="tools-title">
            <i class="simple-icon-wrench"></i>
            ${'tools.activeTools'.t()}
        </h2>
        <button class="global-toggle-btn" 
                @click="${(x, c) => x.toggleGlobalCollapse()}"
                title="${x => x.globalCollapsed ? 'tools.expandAll'.t() : 'tools.collapseAll'.t()}">
            <i class="${x => x.globalCollapsed ? 'simple-icon-arrow-down' : 'simple-icon-arrow-up'}"></i>
        </button>
    </div>

    ${(0, fast_element_1.repeat)(x => x.data, (0, fast_element_1.html) `
        <div class="tool-entry ${(tool, c) => c.parent.globalCollapsed ? 'collapsed' : ''}">
            <div class="tool-header">
                <i class="tool-icon ${(tool, c) => c.parent.getToolIcon(tool.toolName)}"></i>
                <div class="tool-info-summary">
                    <div class="tool-name">${(tool, c) => c.parent.getToolDisplayName(tool.toolName)}</div>                    
                </div>
            </div>
            
            <div class="tool-content ${(tool, c) => c.parent.globalCollapsed ? 'collapsed' : 'expanded'}">
                <div class="tool-content-inner">
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'rag', (0, fast_element_1.html) `
                        <rws-tools-rag-data :ragData="${tool => tool.data}"></rws-tools-rag-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'webSearch', (0, fast_element_1.html) `
                        <rws-tools-web-search-data :webSearchData="${tool => tool.data}"></rws-tools-web-search-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'productCard', (0, fast_element_1.html) `
                        <rws-tools-product-card-data :productCardData="${tool => tool.data}"></rws-tools-product-card-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'productCompare', (0, fast_element_1.html) `
                        <rws-tools-product-compare-data :productCompareData="${tool => tool.data}"></rws-tools-product-compare-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'detectContactData', (0, fast_element_1.html) `
                        <rws-tools-detect-contact-data :contactData="${tool => tool.data}"></rws-tools-detect-contact-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'detectTasks', (0, fast_element_1.html) `
                        <rws-tools-detect-tasks-data :tasksData="${tool => tool.data}"></rws-tools-detect-tasks-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'offerCreator', (0, fast_element_1.html) `
                        <rws-tools-offer-creator-data :offerData="${tool => tool.data}"></rws-tools-offer-creator-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'quickOffer', (0, fast_element_1.html) `
                        <rws-tools-quick-offer-data :quickOfferData="${tool => tool.data}"></rws-tools-quick-offer-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'sendContactForm', (0, fast_element_1.html) `
                        <rws-tools-send-contact-form-data :contactFormData="${tool => tool.data}"></rws-tools-send-contact-form-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'convoTags', (0, fast_element_1.html) `
                        <rws-tools-convo-tags-data :tagsData="${tool => tool.data}"></rws-tools-convo-tags-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'galleryTags', (0, fast_element_1.html) `
                        <rws-tools-gallery-tags-data :tagsData="${tool => tool.data}"></rws-tools-gallery-tags-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'askForVoucher', (0, fast_element_1.html) `
                        <rws-tools-ask-for-voucher-data :voucherData="${tool => tool.data}"></rws-tools-ask-for-voucher-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'dynamicListings', (0, fast_element_1.html) `
                        <rws-tools-dynamic-listings-data :listingsData="${tool => tool.data}"></rws-tools-dynamic-listings-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'productAPISearch', (0, fast_element_1.html) `
                        <rws-tools-product-api-search-data :productAPISearchData="${tool => tool.data}"></rws-tools-product-api-search-data>
                    `)}
                    ${(0, fast_element_1.when)(tool => tool.toolName === 'apiTool', (0, fast_element_1.html) `
                        <rws-tools-api-tool-data :apiToolData="${tool => tool.data}"></rws-tools-api-tool-data>
                    `)}
                </div>
            </div>
        </div>
    `)}
    
    ${(0, fast_element_1.when)(x => !x.data || x.data.length === 0, (0, fast_element_1.html) `
        <div class="empty-state">
            <i class="simple-icon-info"></i>
            <p>${'tools.noActiveTools'.t()}</p>
        </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.rws-tools-container {
  margin: 8px 0;
  font-family: var(--font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  background: var(--bg-primary, #ffffff);
  border-radius: 8px;
  border: 1px solid var(--border-color, #e1e5e9);
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.rws-tools-container .tools-header {
  background: var(--primary-color, #007acc);
  color: white;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.rws-tools-container .tools-header .tools-title {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.rws-tools-container .tools-header .tools-title i {
  font-size: 1.1em;
}
.rws-tools-container .tools-header .global-toggle-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}
.rws-tools-container .tools-header .global-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}
.rws-tools-container .tools-header .global-toggle-btn i {
  font-size: 1em;
}
.rws-tools-container .tool-entry {
  border-bottom: 1px solid var(--border-color-light, #f0f0f0);
  transition: all 0.3s ease-in-out;
}
.rws-tools-container .tool-entry:last-child {
  border-bottom: none;
}
.rws-tools-container .tool-entry.collapsed .tool-content {
  max-height: 0;
  opacity: 0;
}
.rws-tools-container .tool-entry .tool-header {
  padding: 6px 12px;
  background: var(--bg-secondary, #f8f9fa);
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  border-left: 2px solid transparent;
}
.rws-tools-container .tool-entry .tool-header .tool-icon {
  font-size: 1rem;
  color: var(--primary-color, #007acc);
  width: 20px;
  text-align: center;
  margin-right: 8px;
}
.rws-tools-container .tool-entry .tool-header .tool-info-summary {
  flex: 1;
}
.rws-tools-container .tool-entry .tool-header .tool-info-summary .tool-name {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  font-size: 0.8rem;
  margin: 0;
}
.rws-tools-container .tool-entry .tool-header .tool-info-summary .tool-status {
  font-size: 0.7rem;
  color: var(--text-secondary, #6c757d);
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 1px;
}
.rws-tools-container .tool-entry .tool-header .tool-info-summary .tool-status::before {
  content: "";
  width: 6px;
  height: 6px;
  background: var(--warning-color, #ffc107);
  border-radius: 50%;
  animation: pulse 2s infinite;
}
.rws-tools-container .tool-entry .tool-content {
  max-height: 1000px;
  opacity: 1;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.rws-tools-container .tool-entry .tool-content.collapsed {
  max-height: 0;
  opacity: 0;
}
.rws-tools-container .tool-entry .tool-content.expanded {
  max-height: auto;
  opacity: 1;
}
.rws-tools-container .tool-entry .tool-content .tool-content-inner {
  padding: 0;
  background: var(--bg-primary, #ffffff);
}
.rws-tools-container .tool-entry .tool-content .tool-content-inner .unknown-tool {
  padding: 20px;
  text-align: center;
  color: var(--warning-color, #ffc107);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
}
.rws-tools-container .tool-entry .tool-content .tool-content-inner .unknown-tool i {
  font-size: 1.2em;
}
.rws-tools-container .empty-state {
  padding: 16px;
  text-align: center;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-container .empty-state i {
  font-size: 1.5rem;
  margin-bottom: 4px;
  display: block;
  color: var(--text-tertiary, #9ca3af);
}
.rws-tools-container .empty-state p {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(0.8);
  }
}

[data-theme=dark] .rws-tools-container {
  background: var(--bg-primary-dark, #1a202c);
  border-color: var(--border-color-dark, #4a5568);
}
[data-theme=dark] .rws-tools-container .tools-header {
  background: var(--primary-color-dark, #2d3748);
  border-bottom-color: rgba(255, 255, 255, 0.05);
}
[data-theme=dark] .rws-tools-container .tools-header .global-toggle-btn {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
}
[data-theme=dark] .rws-tools-container .tools-header .global-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}
[data-theme=dark] .rws-tools-container .tool-entry {
  border-bottom-color: var(--border-color-dark, #4a5568);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header:hover {
  background: var(--bg-tertiary-dark, #374151);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-icon {
  color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-name {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-status {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-status::before {
  background: var(--warning-color-dark, #fbd38d);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-right .collapse-btn {
  border-color: var(--border-color-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-header .tool-header-right .collapse-btn:hover {
  background: var(--primary-color-dark, #63b3ed);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-content .tool-content-inner {
  background: var(--bg-primary-dark, #1a202c);
}
[data-theme=dark] .rws-tools-container .tool-entry .tool-content .tool-content-inner .unknown-tool {
  color: var(--warning-color-dark, #fbd38d);
}
[data-theme=dark] .rws-tools-container .empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-container .empty-state i {
  color: var(--text-tertiary-dark, #718096);
}

@media (max-width: 768px) {
  .rws-tools-container {
    margin: 16px 0;
    border-radius: 12px;
  }
  .rws-tools-container .tools-header {
    padding: 12px 16px;
  }
  .rws-tools-container .tools-header .tools-title {
    font-size: 1.1rem;
    gap: 8px;
  }
  .rws-tools-container .tools-header .tools-title i {
    font-size: 1em;
  }
  .rws-tools-container .tools-header .global-toggle-btn {
    padding: 6px 8px;
  }
  .rws-tools-container .tool-entry .tool-header {
    padding: 12px 16px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left {
    gap: 10px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-icon {
    font-size: 1.2rem;
    width: 28px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-name {
    font-size: 0.9rem;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-status {
    font-size: 0.8rem;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-right .collapse-btn {
    padding: 4px 6px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-right .collapse-btn i {
    font-size: 0.8em;
  }
  .rws-tools-container .tool-entry .tool-content .tool-content-inner .unknown-tool {
    padding: 16px;
    font-size: 0.9rem;
  }
  .rws-tools-container .empty-state {
    padding: 32px 20px;
  }
  .rws-tools-container .empty-state i {
    font-size: 2rem;
  }
  .rws-tools-container .empty-state p {
    font-size: 0.9rem;
  }
}
@media (max-width: 768px) and (max-width: 480px) {
  .rws-tools-container {
    margin: 12px 0;
    border-radius: 8px;
  }
  .rws-tools-container .tools-header {
    padding: 10px 12px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  .rws-tools-container .tools-header .tools-title {
    font-size: 1rem;
  }
  .rws-tools-container .tool-entry .tool-header {
    padding: 10px 12px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-icon {
    font-size: 1.1rem;
    width: 24px;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-name {
    font-size: 0.85rem;
  }
  .rws-tools-container .tool-entry .tool-header .tool-header-left .tool-info-summary .tool-status {
    font-size: 0.75rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsComponent = class RWSToolsComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.collapsedItems = new Set();
        this.globalCollapsed = true;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    toggleToolCollapse(index) {
        if (this.collapsedItems.has(index)) {
            this.collapsedItems.delete(index);
        }
        else {
            this.collapsedItems.add(index);
        }
        // Trigger reactivity
        this.collapsedItems = new Set(this.collapsedItems);
    }
    isToolCollapsed(index) {
        return this.globalCollapsed || this.collapsedItems.has(index);
    }
    toggleGlobalCollapse() {
        this.globalCollapsed = !this.globalCollapsed;
        if (this.globalCollapsed) {
            this.collapsedItems.clear();
        }
        this.collapsedItems = new Set(this.collapsedItems);
    }
    getToolIcon(toolName) {
        switch (toolName) {
            case 'webSearch':
            case 'web-search':
                return 'simple-icon-magnifier';
            case 'rag':
                return 'simple-icon-book-open';
            case 'productCard':
            case 'product-card':
                return 'simple-icon-bag';
            case 'productCompare':
                return 'simple-icon-chart';
            case 'detectContactData':
                return 'simple-icon-user';
            case 'detectTasks':
                return 'simple-icon-note';
            case 'offerCreator':
                return 'simple-icon-docs';
            case 'quickOffer':
                return 'simple-icon-list';
            case 'sendContactForm':
                return 'simple-icon-envelope';
            case 'convoTags':
                return 'simple-icon-tag';
            case 'galleryTags':
                return 'simple-icon-picture';
            case 'askForVoucher':
                return 'simple-icon-present';
            case 'dynamicListings':
                return 'simple-icon-layers';
            case 'productAPISearch':
                return 'simple-icon-basket';
            case 'apiTool':
                return 'simple-icon-link';
            default:
                return 'simple-icon-wrench';
        }
    }
    getToolDisplayName(toolName) {
        switch (toolName) {
            case 'webSearch':
            case 'web-search':
                return 'tools.webSearch'.t();
            case 'rag':
                return 'tools.rag'.t();
            case 'productCard':
            case 'product-card':
                return 'tools.productCard'.t();
            case 'productCompare':
                return 'tools.productCompare.name'.t();
            case 'detectContactData':
                return 'tools.detectContactData.name'.t();
            case 'detectTasks':
                return 'tools.detectTasks.name'.t();
            case 'offerCreator':
                return 'tools.offerCreator.name'.t();
            case 'quickOffer':
                return 'tools.quickOffer.name'.t();
            case 'sendContactForm':
                return 'tools.sendContactForm.name'.t();
            case 'convoTags':
                return 'tools.convoTags.name'.t();
            case 'galleryTags':
                return 'tools.galleryTags.name'.t();
            case 'askForVoucher':
                return 'tools.askForVoucher.name'.t();
            case 'dynamicListings':
                return 'tools.dynamicListings.name'.t();
            case 'productAPISearch':
                return 'tools.productAPISearch.name'.t();
            case 'apiTool':
                return 'tools.apiTool.name'.t();
            default:
                return `tools.${toolName}.name`.t();
        }
    }
};
exports.RWSToolsComponent = RWSToolsComponent;
__decorate([
    client_1.jsonAttr,
    __metadata("design:type", Array)
], RWSToolsComponent.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Set !== "undefined" && Set) === "function" ? _a : Object)
], RWSToolsComponent.prototype, "collapsedItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RWSToolsComponent.prototype, "globalCollapsed", void 0);
exports.RWSToolsComponent = RWSToolsComponent = __decorate([
    (0, client_1.RWSView)('rws-tools', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsComponent);
RWSToolsComponent.defineComponent();
